// Module
var code = "<div class=\"section-container sign-out\"><h1 translate-once=\"settings.sign_out.signing_out\"></h1></div>";
// Exports
export default code;